<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<h4 *ngIf="GetScanType() == 0">Scan Details</h4>
				<h4 *ngIf="GetScanType() == 1">Entry Scan Details</h4>
				<h4 *ngIf="GetScanType() == 2">Exit Scan Details</h4>
				<h4 *ngIf="GetScanType() == 3">Meal Scan Details</h4>
				<h4 *ngIf="GetScanType() == 4">Access Scan Details</h4>
				<h4 *ngIf="GetScanType() == 5">Time Scan Details</h4>
				<h4 *ngIf="GetScanType() == 6">Event Scan Details</h4>

				<!--Entry-->
				<div class="DetailsGrid" *ngIf="GetScanType() == 1">
					<label>Synced Up Date:</label>
					<p>{{ LogDTDesc }}</p>

					<label>Used For Attendance:</label>
					<p>{{ UsedForAttendance }}</p>

					<!-- <label>Entry Date:</label>
					<p>{{ EntryDate }}</p>

					<label>Entry Time:</label>
					<p>{{ EntryTime }}</p>

					<label>Attendance Status:</label>
					<p>{{ AttendanceStatusDesc }}</p>

					<label>Excuse:</label>
					<p>{{ ExcuseDesc }}</p>

					<label>Release Type:</label>
					<p>{{ ReleaseTypeDesc }}</p>

					<label>Student Is Suspended:</label>
					<p>{{ SuspendedDesc }}</p>

					<label>Scan Created By:</label>
					<p>{{ CreatedByName }}</p>

					<label>Comments:</label>
					<p>{{ Comment }}</p>

					<label>Attendance Is Tentative:</label>
					<p>{{ TentativeDesc }}</p> -->
				</div>

				<!--Exit-->
				<div class="DetailsGrid" *ngIf="GetScanType() == 2">
					<label>Synced Up Date:</label>
					<p>{{ LogDTDesc }}</p>

					<label>Student Has Release:</label>
					<p>{{ StudentHasRelease }}</p>

					<label>Release Type:</label>
					<p>{{ ReleaseTypeDesc }}</p>

					<label>Created By:</label>
					<p>{{ AdminName }}</p>

					<label>Release is Part of a Group Action:</label>
					<p>{{ IsAGroupAction }}</p>

					<label>Group:</label>
					<p>{{ GroupDesc }}</p>

					<label>Group Action Type:</label>
					<p>{{ GroupActionDesc }}</p>

					<label>Excuse:</label>
					<p>{{ ExcuseDesc }}</p>

					<label>Start Date:</label>
					<p>{{ StartDate }}</p>

					<label>End Date:</label>
					<p>{{ EndDate }}</p>

					<label>Admit Time:</label>
					<p>{{ AdmitTime }}</p>

					<label>Release Time:</label>
					<p>{{ ReleaseTime }}</p>

					<label>Comments:</label>
					<p>{{ Comment }}</p>

					<label>Release Active:</label>
					<p>{{ ReleaseActiveDesc }}</p>

					<label>Release Days:</label>
					<p>{{ DaysStr }}</p>
				</div>

				<!--Meal-->
				<div class="DetailsGrid" *ngIf="GetScanType() == 3">
					<label>Synced Up Date:</label>
					<p>{{ LogDTDesc }}</p>

					<label>Scan is Associated with a Meal History:</label>
					<p>{{ MealHistoryExists }}</p>

					<label>Meal Date/Time:</label>
					<p>{{ MealHistoryDT }}</p>

					<label>Meal Name:</label>
					<p>{{ MealName }}</p>

					<label>Meal Start Time:</label>
					<p>{{ MealStartTime }}</p>

					<label>Meal End Time:</label>
					<p>{{ MealEndTime }}</p>

					<label>Meal Price:</label>
					<p>{{ MealPrice }}</p>

					<label>Student's Subsidy Type:</label>
					<p>{{ MealSubsidyDesc }}</p>
				</div>

				<!--Access-->
				<div class="DetailsGrid" *ngIf="GetScanType() == 4">
					<label>Synced Up Date:</label>
					<p>{{ LogDTDesc }}</p>

					<label>Access Mode:</label>
					<p>{{ ScanAccessModeDesc }}</p>

					<label *ngIf="ScanAccessModeDesc == 'Course Type'">Course Type:</label>
					<p *ngIf="ScanAccessModeDesc == 'Course Type'">
						{{ CourseTypeDesc }}
					</p>

					<label *ngIf="ScanAccessModeDesc == 'Course/Section'">Section:</label>
					<p *ngIf="ScanAccessModeDesc == 'Course/Section'">
						{{ SectionInfo }}
					</p>

					<label *ngIf="ScanAccessModeDesc == 'Room'">Room Number:</label>
					<p *ngIf="ScanAccessModeDesc == 'Room'">{{ RoomNo }}</p>
				</div>

				<!--Time Stamp-->
				<div class="DetailsGrid" *ngIf="GetScanType() == 5">
					<label>Synced Up Date:</label>
					<p>{{ LogDTDesc }}</p>

					<label>Time Stamp Mode:</label>
					<p>{{ TimeScanTypeDesc }}</p>

					<label>Time Stamp Date/Time:</label>
					<p>{{ TimeScanDT }}</p>
				</div>

				<!--Event-->
				<div class="DetailsGrid" *ngIf="GetScanType() == 6">
					<label>Synced Up Date:</label>
					<p>{{ LogDTDesc }}</p>

					<label>Event Name:</label>
					<p>{{ EventDescShort }}</p>

					<label>Event Description:</label>
					<p>{{ EventDescLong }}</p>

					<label>Event Location:</label>
					<p>{{ EventLocation }}</p>

					<label>Event Date/Time:</label>
					<p>{{ EventDT }}</p>

					<label>Doors Open Time:</label>
					<p>{{ DoorsOpenTime }}</p>

					<label>Start Time:</label>
					<p>{{ StartTime }}</p>

					<label>End Time:</label>
					<p>{{ EndTime }}</p>

					<label>Recurrance Type:</label>
					<p>{{ RecurranceTypeDesc }}</p>

					<label>Range Start Date:</label>
					<p>{{ RangeStartDate }}</p>

					<label>Range End Date:</label>
					<p>{{ RangeEndDate }}</p>
				</div>
			</div>
		</div>
	</div>
</div>
